import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import svg from './svg';
import labels from './labels';
import axios from 'axios'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    urls: {},
    errors:[],

    schemaUrl: '',

    dialogs: {
      add: false,
      edit: false,
      delete: false,
      resendMail: false,
      priceChange: false,
      addSubscriber: false,
      subscriptionMain: false,
      transactionDetails: false,
      deleteSubscription: false,
      createSubscription: false,
      updateSubscription: false,
      editTicketTheatre: false,
    },

    schema: {},
    currentTab: {},
    previousTab: {},

    isAdmin: false,
    isTheatre: false,

    loading: false,
    clicked: false,
    showNotification: false,
    notificationInterval: null,
    apiVersion: '',

    csrf: null,
    selectedSeats: [],
    pageLoaded: false,
    isTicket: false,
    currentStageKind: 1,
    defaultPricelistID: 1,
    hoveredSeatInfo: {},
    activeSeasonID: null,
    theatreLoaded: false,
		performanceOver: false,
		promoCode: undefined,
    selectedObject: {},
    hoverBoxPosition: {x:0, y:0},
    seatInfoVisiblity: 'is-hidden',
    ansemble:{
      1: 'Opera',
      2: 'Balet',
      3: 'Drama',
      4: 'Filozofski teatar',
      5: 'Koncerti',
      6: 'Dječji programi',
      7: 'Gala večeri',
      8: 'Posebni programi',
      9: 'Tajna povijest kazališta',
      10: 'Razgledavanje kazališta'
    },
    stageKinds:{
      1: 'Glavna pozornica',
      2: 'Foyer',
      3: 'Muzička akademija',
      4: 'Festival svjetskog kazališta',
      5: 'Tonski studio',
      6: 'Gostovanja 500',
      7: 'Gostovanja 1200',
      0: 'Nenumerirano gledalište',
    },
    kindsMapper:{
      'm-c': 'Centralne Lože Mezanin od 7-11',
      'k-c': 'Centralne Lože Kat 7-11',
      'p-f': 'Parket I-VI',
      'p-r': 'Parket VII-XIV',
      'm-s': 'Mezanin Lože 1-6',
      'k-s': 'Kat Lože 1-6',
      'b': 'Balkon 1-5',
      'lb': 'Lože Balkon',
      'ma': 'Muzička Akademija',
      'ts': 'Tonski studio',
      'f': 'Foyer',
			'live': 'Live stream',
      'coupon': 'Kupon',
      'fsk': 'Festival Svjetskog Kazališta',
      'g500': 'Gostovanja 500',
      'g1200': 'Gostovanja 1200',
      'proscenium': 'Nenumerirana sjedala / Proscenij',
    },

    createTransactionError: false,

    //RECEIVED OBJECTS
    theatre: null,
    currentTransaction: null,

    //SIMPLE GETTERS
    simpleData: [
      'seasons',
      'seasonsList',
      'stages',
      'plays',
      'pricelistsList',
      'sponsors',
      'leases',
      'employees',
      'subscriptionBundle',
      'coupons',
      'promoCodes',
      'workPlaces',
      'performances',
      'performancesSimple',
      'ticketTheatre',
      'reservations',
      'transactionsCoupon',
      'reportsGeneralAll',
    ],

    ticketTabs: [
      'pricelistLists',
      'discounts',
      'stages',
      'performances',
      'plays',
      'partners',
      'leases',
      'sponsors',
      'ticketSales',
    ],

    //RECEIVED LISTS
    receivedData: {
      subscriptionSales: {
        tab: false,
        url: 'transakcije/pretplate/prodaja',
        get: 'getTransactions',
        title: 'Transakcije',
        list: [],
      },
      ticketSales: {
        tab: false,
        additionalSimpleGet: ['performancesSimple'],
        get: 'getTransactions',
        url: 'transakcije/ulaznice/prodaja',
        title: 'Transakcije',
        list: [],
      },
      subscribers: {
        tab: false,
        url: 'pretplatnici',
        title: 'Pretplatnici',
        additionalSimpleGet: ['subscriptionBundle'],
        list: [],
      },
      subscriptionBundle: {
        list: [],
      },
      reservations: {
        tab: false,
        url: 'transakcije/pretplate/rezervacije',
        title: 'Rezervacije',
        list: [],
      },
      subscriptions: {
        tab: true,
        url: 'pretplate',
        get: 'getSubscriptions',
        title: 'Pretplate',
        list: [],
      },
      reportsGeneral: {
        tab: false,
        url: 'izvjesca/po-pretplatama',
        get: 'getReportsGeneral',
        title: 'Izvješća po pretplatama',
        list: [],
      },
      reportsPayment: {
        tab: false,
        url: 'izvjesca/po-nacinu-placanja',
        get: 'getReportsPayment',
        title: 'Izvješća po načinu plaćanja',
        list: [],
      },
      transactionDetails: {
        tab: false,
        url: 'detalji-transakcije',
        title: 'Detalji transakcije',
        list: [],
      },
      subscriptionTheatre: {
        tab: false,
        url: 'tlocrt-pretplate',
        list: [],
      },
      ticketTheatre: {
        tab: false,
        url: 'tlocrt-ulaznice',
        additionalSimpleGet: ['sponsors','leases','discounts'],
        list: [],
      },
      pricelists: {
        list: [],
      },
      seasons: {
        list: [],
      },
      subscribersExport: {
        get: 'getSubscribersExport',
        list: [],
      },
      discounts: {
        tab: false,
        url: 'popusti',
        get: 'getDiscounts',
        title: 'Popusti',
        list: [],
      },
      pricelistsList: {
        tab: false,
        url: 'cjenici',
        additionalGet: ['getDiscounts'],
        title: 'Cjenici',
        list: [],
      },
      stages: {
        tab: false,
        url: 'pozornice',
        title: 'Pozornice',
        list: [],
      },
      plays: {
        tab: false,
        url: 'predstave',
        title: 'Predstave',
        list: [],
      },
      performances: {
        tab: false,
        url: 'raspored',
        additionalGet: ['getDiscounts'],
        additionalSimpleGet: ['plays', 'stages', 'seasonsList', 'pricelistsList', 'subscriptionBundle'],
        title: 'Raspored',
        list: [],
      },
      performancesSimple: {
        tab: false,
        list: [],
      },
      kontoHR: {
        tab: false,
        url: 'konto-hr',
        title: 'Konto HR'
      },
      sponsors: {
        tab: false,
        url: 'sponzori',
        title: 'Sponzori',
        list: [],
      },
      partners: {
        tab: false,
        url: 'poslovni-partneri',
        title: 'Poslovni partneri',
        list: [],
      },
      leases: {
        tab: false,
        url: 'zakupi',
        title: 'Zakupi',
        list: [],
      },
      reportsIncome: {
        tab: false,
        url: 'izvjesca/promet-u-periodu',
        get: 'getReportsIncome',
        title: 'Promet u periodu',
        list: [],
      },
      reportsPlay: {
        tab: false,
        url: 'izvjesca/po-predstavi',
        additionalSimpleGet: ['performancesSimple'],
        title: 'Izvješća po predstavi',
        list: [],
      },
      reportsCash: {
        tab: false,
        url: 'izvjesca/gotovinsko',
        get: 'getReportsCash',
        title: 'Gotovinsko izvješće',
        list: {},
      },
      reportsPlayOnline: {
        tab: false,
        url: 'izvjesca/po-predstavi-online',
        additionalSimpleGet: ['performancesSimple'],
        title: 'Izvješća po predstavi - Online',
        list: [],
      },
      reportsCashRegister: {
        tab: false,
        get: 'getReportsCashRegister',
        url: 'izvjesca/blagajnicki',
        title: 'Blagajnički izvještaj',
        list: [],
      },
      reportsGratisByDate: {
        tab: false,
        url: 'izvjesca/gratis-po-danima',
        additionalSimpleGet: ['performancesSimple'],
        title: 'Gratis po danima',
        list: [],
      },
      reportsGeneralAll: {
        tab: false,
        url: 'izvjesca/kumulativni-sve-predstave',
        title: 'Kumulativni izvještaj - sve predstave',
        list: [],
      },
      reportsCashRegisterPlay: {
        tab: false,
        additionalGet: ['getReportsCashRegister'],
        url: 'izvjesca/blagajnicki-predstava',
        title: 'Blagajnički izvještaj - Predstava',
        list: [],
      },
      seasonsList: {
        tab: false,
        url: 'sezone',
        title: 'Sezone',
        list: [],
      },
      employees: {
        tab: false,
        url: 'zaposlenici',
        additionalSimpleGet: ['workPlaces', 'employees'],
        title: 'Zaposlenici',
        list: [],
      },
      offers: {
        tab: false,
        url: 'ponude',
        get: 'getOffers',
        additionalSimpleGet: ['performancesSimple'],
        title: 'Ponude',
        list: [],
      },
      sold: {
        tab: false,
        url: 'prodano',
        get: 'getSold',
        additionalSimpleGet: ['performancesSimple'],
        title: 'Prodano',
        list: [],
      },
      workPlaces: {
        tab: false,
        url: 'radna-mjesta',
        title: 'Radna mjesta',
        list: [],
      },
      coupons: {
        tab: false,
        url: 'kuponi',
        additionalSimpleGet: ['transactionsCoupon'],
        title: 'Kuponi',
        list: [],
      },
      promoCodes: {
        tab: false,
        url: 'promo-kodovi',
        additionalSimpleGet: ['promoCodes'],
        title: 'Promo kodovi',
        list: [],
      },
      transactionsCoupon:{
        tab: false,
        url: 'kuponi/transakcije',
        title: 'Kuponi - Transakcije',
        list: [],
      },
      transactionsPromoCodes:{
        tab: false,
        url: 'promo-kodovi/transakcije',
        title: 'Promo kodovi - Transakcije',
        list: [],
      },
      reportsPerformanceGeneral:{
        tab: false,
        get: 'getReportsPerformanceGeneral',
        url: 'izvjesca/kumulativni',
        title: 'Kumulativni izvještaj',
        list: [],
      },
      reportsAboutPlay:{
        tab: false,
        additionalSimpleGet: ['performancesSimple'],
        url: 'izvjesca/o-izvedbi',
        title: 'Izvještaj o izvedbi',
        list: [],
      },
      reportsAboutScan:{
        tab: false,
        additionalSimpleGet: ['performancesSimple'],
        url: 'izvjesca/skenirano',
        title: 'Izvještaj o skeniranim ulaznicama',
        list: [],
      },
      editTransaction:{
        tab: false,
        additionalSimpleGet: ['sponsors','leases','discounts'],
        url: 'tlocrt-ulaznice/uredi',
        title: 'Uređivanje transakcije',
      },
      showScreen: {
        tab: false,
        url: 'show-screen',
        title: 'Prikaz tlocrta',
      },
      reportsInGuests: {
        tab: false,
        url: 'izvjesca/u-gostima',
        title: 'Izvještaj u gostima',
        list: [],
      },
    },

    //THEATRE
    ...svg,
    ...labels,
    rowIDs: {
      'p-l':{
        title: 'Parket',
        position: 'Parket',
      },
      'p-r':{
        title: 'Parket',
        position: 'Parket',
      },
      'lb-l':{
        title: 'Lože Balkon',
        position: 'Balkon'
      },
      'lb-r':{
        title: 'Lože Balkon',
        position: 'Balkon'
      },
      'b-l':{
        title: 'Balkon',
        position: 'Balkon'
      },
      'b-r':{
        title: 'Balkon',
        position: 'Balkon'
      },
      'm-l':{
        title: 'Lože mezanin',
        position: 'Loža'
      },
      'm-r':{
        title: 'Lože mezanin',
        position: 'Loža'
      },
      'k-l':{
        title: 'Lože 1. Kat',
        position: 'Loža'
      },
      'k-r':{
        title: 'Lože 1. Kat',
        position: 'Loža'
      },
      'ma-l':{
        title: 'Muzička akademija',
        position: 'Parket'
      },
      'ma-r':{
        title: 'Muzička akademija',
        position: 'Parket'
      },
      'f-l':{
        title: 'Foyer',
        position: 'Parket'
      },
      'f-r':{
        title: 'Foyer',
        position: 'Parket'
      },
      'ts-l':{
        title: 'Tonski studio',
        position: 'Parket'
      },
      'ts-r':{
        title: 'Tonski studio',
        position: 'Parket'
      },
      'fsk-l':{
        title: 'FSK',
        position: 'Parket'
      },
      'fsk-r':{
        title: 'FSK',
        position: 'Parket'
      },
      'dt-l':{
        title: '12x30',
        position: 'Parket'
      },
      'dt-r':{
        title: '12x30',
        position: 'Parket'
      },
      'g500-l':{
        title: 'Gostovanja 500',
        position: 'Parket'
      },
      'g500-r':{
        title: 'Gostovanja 500',
        position: 'Parket'
      },
      'g1200-l':{
        title: 'Gostovanja 1200',
        position: 'Parket'
      },
      'g1200-r':{
        title: 'Gostovanja 1200',
        position: 'Parket'
      },
    },

    categories: {
      0:{
        price: 0,
      },
      1:{
        rows: ['m-l-7','m-l-8','m-l-9','m-l-10','m-l-11','k-l-7','k-l-8','k-l-9','k-l-10','k-l-11','m-r-7','m-r-8','m-r-9','m-r-10','k-r-7','k-r-8','k-r-9','k-r-10','k-r-11','ma-l-1','ma-l-2','ma-l-3','ma-l-4','ma-l-5','ma-l-6','ma-l-7','ma-l-8','ma-l-9','ma-l-10','ma-l-11','ma-l-12','ma-r-1','ma-r-2','ma-r-3','ma-r-4','ma-r-5','ma-r-6','ma-r-7','ma-r-8','ma-r-9','ma-r-10','ma-r-11','ma-r-12','f-l-1','f-l-2','f-l-3','f-l-4','f-l-5','f-r-1','f-r-2','f-r-3','f-r-4','f-r-5','f-l-6','f-l-7','f-l-8','f-l-8','f-l-10','f-r-6','f-r-7','f-r-8','f-r-9','f-r-10','fsk-l-1','fsk-l-2','fsk-l-3','fsk-l-4','fsk-l-5','fsk-l-6','fsk-l-7','fsk-l-8','fsk-l-9','f-l-10','fsk-r-1','fsk-r-2','fsk-r-3','fsk-r-4','fsk-r-5','fsk-r-6','fsk-r-7','fsk-r-8','fsk-r-9','ts-l-1','ts-l-2','ts-l-3','ts-l-4','ts-l-5','ts-r-1','ts-r-2','ts-r-3','ts-r-4','ts-r-5'],
        price: 90.00,
      },
      2:{
        rows: ['p-l-1','p-l-2','p-l-3','p-l-4','p-l-5','p-l-6','p-r-1','p-r-2','p-r-3','p-r-4','p-r-5','p-r-6'],
        price: 75.00,
      },
      3:{
        rows: ['p-l-7','p-l-8','p-l-9','p-l-10','p-l-11','p-l-12','p-l-13','p-l-14','p-r-7','p-r-8','p-r-9','p-r-10','p-r-11','p-r-12','p-r-13','p-r-14','m-l-1','m-l-2','m-l-3','m-l-4','m-l-5','m-l-6','k-l-1','k-l-2','k-l-3','k-l-4','k-l-5','k-l-6','m-r-1','m-r-2','m-r-3','m-r-4','m-r-5','m-r-6','k-r-1','k-r-2','k-r-3','k-r-4','k-r-5','k-r-6'],
        price: 70.00,
      },
      4:{
        rows: ['lb-l-2','lb-l-3','lb-r-2','lb-r-3','b-l-1','b-l-2','b-l-3','b-l-4','b-l-5','b-r-1','b-r-2','b-r-3','b-r-4','b-r-5'],
        price: 55.00,
      },
    },
  },


  //GETTERS
  getters: {
    getSeatInfo: state => (seat, row, seatID, rowID) => {
      let orientation = rowID.split('-')[1] == 'l' ? 'Lijevo' : 'Desno'
	    let cat = parseInt(row.category);
      if(["m-l-1-5", "m-l-2-5", "m-l-3-5", "m-l-4-5", "m-l-5-5", "m-l-6-5", "m-r-6-5", "m-r-5-5", "m-r-4-5", "m-r-3-5", "m-r-2-5", "m-r-1-5", "k-l-1-5", "k-l-2-5", "k-l-3-5", "k-l-4-5", "k-l-5-5", "k-l-6-5", "k-r-6-5", "k-r-5-5", "k-r-4-5", "k-r-3-5", "k-r-2-5", "k-r-1-5"].includes(rowID+'-'+seatID)) cat += 1;

      return {
        rowID: rowID,
        seatID: seatID,
        category: cat,
        orientation: orientation,
        rowNumber: rowID.split('-')[2],
        price: state.categories[cat].price,
        discount: state.categories[cat].discount,
        row: state.rowIDs[rowID.split('-').slice(0, 2).join('-')],
        status: seat.status,
        person: {},
      }
    },

    getFullPrice: (state, getters) => (discount, custom_discount) => {
      let price = 0;
			if (state.currentTransaction && state.currentTransaction.kind == 'live-performance')
				return state.theatre.live_price;
      getters.getSelectedSeats.forEach((seat) =>{
        if(!discount) price+=parseFloat(seat.price);
        else price+=parseFloat(seat.discount);
      })

	    if (state.isSubscription && state.theatre.id==89)
		    return price - Math.max(getters.getSelectedSeats.length-2, 0)*200
			if (state.promoCode)
				price *= 1 - (state.promoCode.amount / 100)
      else if (custom_discount)
        return price - price * custom_discount/100.0;
      return price;
    },

    getSelectedSeats: (state, getters) => {
      let seats = [];
      let key = null;
      for(key in state.selectedSeats){
        let rowID = state.selectedSeats[key].rowID;
        let seatID = state.selectedSeats[key].seatID;
        let row = state.theatre.rows[rowID];
        let seat = row.seats[seatID];
        seats.push(getters.getSeatInfo(seat, row, seatID, rowID))
      }
      //obiteljska pretplata
      if (state.isSubscription && [117, 118].includes(state.theatre.id) && seats.length > 2){
		    for(let i = 2; i < seats.length; i++){
          seats[i].price -=30;
        }
      }

      return seats;
    },

    getSeatWithRow: (state, getters) => {
      let seats = [];
      getters.getSelectedSeats.forEach((seat) =>{
        seats.push(seat.rowID+'-'+seat.seatID);
      });

      return seats;
    },

    getSeasonData: (state, getters) => {
      let seasonData = null;
      if(Object.keys(state.selectedObject).length > 0){
        state.selectedObject.seasons.forEach((season) =>{
          if(season.season_id == state.activeSeasonID){
            seasonData = season;
          }
        });
      }

      return seasonData;
    },

    getStatus: (state) => (status, cancelled=false, cancelledID='') => {
      let returnStatus = '';
      switch(status){
        case 'offline_sold':
        returnStatus = 'Prodano - Blagajna';
        break;
        case 'online_sold':
        returnStatus = 'Prodano - Web';
        break;
        case 'offline_checkout':
        returnStatus = 'U čekanju (Blagajna)';
        break;
        case 'online_checkout':
        returnStatus = 'U čekanju (Web)';
        break;
        case 'reservation':
        returnStatus = 'Rezervacija';
        break;
        case 'cancelled':
        returnStatus = `Storno - <b>ID: ${cancelledID}</b>`;
        break;
        case 'expired':
        returnStatus = 'Isteklo';
        break;
        case 'aborted':
        returnStatus = 'Prekinuto';
        break;
        case 'available':
        returnStatus = 'Slobodno';
        break;
        case 'unavailable':
        returnStatus = 'Sistemski zauzeto';
        break;
        case 'locked':
        returnStatus = 'Onemogućeno';
        break;
        case 'subscription':
        returnStatus = 'Pretplate';
        break;
        case 'online_payment_error':
        returnStatus = 'Greška plaćanja';
        break;
        case 'lease':
        returnStatus = 'Zakup';
        break;
        case 'sponsor':
        returnStatus = 'Prodano - Sponzorsko';
        break;
        case 'partner_checkout':
        returnStatus = 'Neautorizirana ponuda';
        break;
        case 'partner_sold':
        returnStatus = 'Autorizirana ponuda';
        break;
        case 'theatre_manager':
        returnStatus = 'Prodano - Intendantica';
        break;
        case 'gratis':
        returnStatus = 'Gratis';
        break;
        case 'system_reserve':
        returnStatus = 'Sistemska rezervacija';
        break;
        case 'used_in_performance':
        returnStatus = 'Korišteno u predstavi';
        break;
        case 'zamjena_web':
        returnStatus = 'Zamjena WEB';
        break;
        case 'zamjena_pretplata':
        returnStatus = 'Zamjena pretplata';
        break;
	case 'zamjena_rezervirano':
        returnStatus = 'Zamjena rezervirano';
        break;
        case 'in_guests':
        returnStatus = 'U gostima';
        break;
        case 'protocol':
        returnStatus = 'Protokol';
        break;
        case 'premiere':
        returnStatus = 'Premijera';
        break;
        case 'najam':
        returnStatus = 'Najam';
        break;
        case 'press':
        returnStatus = 'PRESS';
        break;
      }


      if(cancelled){
        returnStatus += ' - <b>Stornirano</b>';
      }

      return returnStatus;
    },

    getHolder: (state) => (subscribers) => {
      let holder = null;
      if(subscribers){
        for(let i = 0; i < subscribers.length; i++){
          if(subscribers[i].holder){
            return `${subscribers[i].first_name} ${subscribers[i].last_name}`;
            break;
          }
        }
      } else return '';
    },

    getFilteredTransactions: (state) => ({searchKey, list}) =>{
      let filteredTransactions = [];
      if(!searchKey.includes('all')){
        list.forEach((transaction) =>{
          if(searchKey.includes(transaction.status) && !transaction.data.is_cancelled) filteredTransactions.push(transaction);
          if(searchKey.includes('cancelled') && transaction.data.is_cancelled) filteredTransactions.push(transaction);
        })
      } else filteredTransactions = list;

      return filteredTransactions;
    },

    getTheatreSeatStatus: (state, getters) => {
      let rowKey = null;
      let seatKey = null;
      let statuses = [];
      if(state.pageLoaded){
        for(rowKey in state.theatre.rows){
          for(seatKey in state.theatre.rows[rowKey].seats){
            let readableStatus = '';
            let status = state.theatre.rows[rowKey].seats[seatKey].status;
            if(status != 'selected'){
              readableStatus = getters.getStatus(status);
              let statusObject = {status, readableStatus};
              if(statuses.filter((status => {return status.status == statusObject.status})).length < 1) statuses.push(statusObject)
            }
          }
        }
      }
      return statuses;
    },

    getSeatSVG: state => (rowID, seatID) => {
      return state.svg[(rowID+'-'+seatID)];
    },

    isSeatInfoVisible: state => {
      return state.seatInfoVisiblity;
    },

    isPageLoaded: state => {
      return state.pageLoaded;
    },
  },

  mutations: {
    setErrors(state, errors){
      state.errors = [];
      errors.forEach(error =>{
        state.errors.push(error);
      })
    },
    toggleSeatState(state, [rowID, seatID]){
      let row, seat, key = null;
      let boxRows = ['k-l', 'k-r', 'm-l', 'm-r'];
      let selectedSeat = {seatID: seatID, rowID: rowID};
      let optA = [ 1379, 1381, 1384, 1387, 1388, 1389, 1394, 1391, 1393, 1398, 1399, 1400, 1401, 1404, 1424, 1432, 1421, 1409, 1410, 1412, 1413, 1415, 1418, 1420];
      let optB = [1380, 1385, 1390, 1403];

      function findClosestAvailableSeat(rowID, seatID, state) {
        const rowSeats = state.theatre.rows[rowID].seats;
        
        // Get all available seats
        const availableSeats = Object.keys(rowSeats)
          .map(Number)
          .filter(seatKey => rowSeats[seatKey].status === 'available');
        
        if (availableSeats.length === 0) {
          return null; // No available seats in this row
        }
      
        // Find the closest seat by distance
        let closestSeatID = availableSeats.reduce((closest, currentSeatID) => {
          const currentDistance = Math.abs(currentSeatID - seatID);
          const closestDistance = Math.abs(closest - seatID);
          return currentDistance < closestDistance ? currentSeatID : closest;
        }, availableSeats[0]);
      
        return closestSeatID;
      }

      function toggleSeatAndPair(state, rowID, seatID) {
        let row = state.theatre.rows[rowID];
        let seat = row.seats[seatID];
        let selectedSeat = { seatID: seatID, rowID: rowID };
      
        if (seat.status === 'available') {
          console.log(`Selecting seat ${seatID}`);
          seat.status = 'selected';
          state.selectedSeats.push(selectedSeat);
      
          // Pairing logic: dynamically find the pair
          let pairedSeatID = findClosestAvailableSeat(rowID, seatID, state);
          if (pairedSeatID && pairedSeatID !== seatID) {
            console.log(`Pairing seat ${seatID} with ${pairedSeatID}`);
            row.seats[pairedSeatID].status = 'selected';
            state.selectedSeats.push({ seatID: pairedSeatID, rowID: rowID });
      
            // Track the pair in both directions
            seat.pairedSeatID = pairedSeatID;
            row.seats[pairedSeatID].pairedSeatID = seatID;
          } else {
            console.warn('No available seat to pair.');
          }
        } else {
          console.log(`Deselecting seat ${seatID}`);
          seat.status = 'available';
      
          // Remove the originally selected seat
          state.selectedSeats = state.selectedSeats.filter(s => !(s.seatID === seatID && s.rowID === rowID));
          console.log("Updated selected seats after removing original:", state.selectedSeats);
      
          // Handle bidirectional deselection
          let pairedSeatID = seat.pairedSeatID;
          if (pairedSeatID) {
            console.log(`Deselecting paired seat ${pairedSeatID}`);
            row.seats[pairedSeatID].status = 'available';
            state.selectedSeats = state.selectedSeats.filter(s => !(s.seatID === pairedSeatID && s.rowID === rowID));
            console.log("Updated selected seats after removing pair:", state.selectedSeats); // Log after removing paired seat
          
            // Log the selected seats' details
            console.log("Final selected seats state: ", JSON.stringify(state.selectedSeats, null, 2));
          
            // Clear both pairing references
            delete seat.pairedSeatID;
            delete row.seats[pairedSeatID].pairedSeatID;
          }
        }
      
        // Trigger reactivity
        state.selectedSeats = [...state.selectedSeats];
      }

      if (state.theatre.id === 2928) {
        // Call the dynamic pairing function for play ID 2928
        toggleSeatAndPair(state, rowID, seatID);
        return; // Exit after handling play ID 2928
      }
      

      for(key in state.theatre.rows){
        if(key == rowID) row = state.theatre.rows[key];
      }

      for(key in row.seats){
        if(key == seatID) seat = row.seats[key];
      }

      let rowName = rowID.split('-');
      rowName = `${rowName[0]}-${rowName[1]}`

      if ((true || (rowID.split('-')[2] < 8 && optB.includes(state.theatre.id))) && !state.isAdmin ) {
        if ((rowID[0] == 'm' || rowID[0] == 'k') && !(state.theatre.id == 1389 && rowName == 'k-r-5')) {
          let newState = state.theatre.rows[rowID].seats[seatID].status == 'selected' ? 'available' : 'selected';
          if(seatID == 1){
            state.theatre.rows[rowID].seats[3].status = newState;
            if (newState == 'selected')
              state.selectedSeats.push({seatID: 3, rowID: rowID})
            else
              state.selectedSeats.forEach((seat, index) =>{
                if(seat.seatID == 3 && seat.rowID == rowID){
                  state.selectedSeats.splice(index, 1)
                }
              })
          }
          else if(seatID == 2){
            state.theatre.rows[rowID].seats[4].status = newState;
            if (newState == 'selected')
              state.selectedSeats.push({seatID: 4, rowID: rowID})
            else
              state.selectedSeats.forEach((seat, index) =>{
                if(seat.seatID == 4 && seat.rowID == rowID){
                  state.selectedSeats.splice(index, 1)
                }
              })
          }
          else if(seatID == 3){
            state.theatre.rows[rowID].seats[1].status = newState;
            if (newState == 'selected')
              state.selectedSeats.push({seatID: 1, rowID: rowID})
            else
              state.selectedSeats.forEach((seat, index) =>{
                if(seat.seatID == 1 && seat.rowID == rowID){
                  state.selectedSeats.splice(index, 1)
                }
              })
          }
          else if(seatID == 4){
            state.theatre.rows[rowID].seats[2].status = newState;
            if (newState == 'selected')
              state.selectedSeats.push({seatID: 2, rowID: rowID})
            else
              state.selectedSeats.forEach((seat, index) =>{
                if(seat.seatID == 2 && seat.rowID == rowID){
                  state.selectedSeats.splice(index, 1)
                }
              })
          }
        }
      }
      if (optB.includes(state.theatre.id) && (rowID[0] == 'm' || rowID[0] == 'k') && rowID.split('-')[2] >= 8 && !state.isAdmin) {
        let newState = state.theatre.rows[rowID].seats[seatID].status == 'selected' ? 'available' : 'selected';
        for (let seatI = 1; seatI <= 5; seatI++)
          if (seatI != seatID)
            state.theatre.rows[rowID].seats[seatI].status = newState;
        if (newState == 'selected') {
          for (let seatI = 1; seatI <= 5; seatI++)
            if (seatI != seatID)
              state.selectedSeats.push({seatID: seatI, rowID: rowID});
        } else
          for (let seatI = 1; seatI <= 5; seatI++)
            state.selectedSeats.forEach((seat, index) => {
              if (seat.rowID == rowID && seat.seatID == seatI)
                state.selectedSeats.splice(index, 1);
            });
      } 
      /*if(boxRows.includes(rowName) && seatID != 5 && !state.dialogs.createSubscription && !state.isAdmin){
        let otherSeatID = (seatID > 2 ? -2 : 2) + parseInt(seatID);
        if (seat.status == 'available') {
          row.seats[otherSeatID].status = 'selected';
          state.selectedSeats.push({seatID: otherSeatID, rowID});
        } else {
          if (row.seats[otherSeatID].status == 'selected')
            row.seats[otherSeatID].status = 'available';
          state.selectedSeats.forEach((seat, index) => seat.seatID == otherSeatID && seat.rowID == rowID && seat.selectedSeats.splice(index, 1));
        }
      }*/

      //if(!state.dialogs.updateSubscription && !state.dialogs.editTicketTheatre){
      if(!state.dialogs.updateSubscription){
        if(!state.isAdmin){
          if(seat.status == 'available'){
            seat.status = 'selected'
            state.selectedSeats.push(selectedSeat)
          } else if(seat.status == 'selected'){
            seat.status = 'available';
            state.selectedSeats.forEach((seat, index) =>{
              if(seat.seatID == seatID && seat.rowID == rowID) state.selectedSeats.splice(index, 1);
            })
          }
        } else{
          if(['available', 'unavailable'].includes(seat.status)){
            seat.previousStatus = seat.status;
            seat.status = 'selected';
            state.selectedSeats.push(selectedSeat)
          } else if(seat.status == 'selected'){
            if(seat.hasOwnProperty('previousStatus')){
              seat.status = seat.previousStatus;
            } else seat.status = 'available';
            state.selectedSeats.forEach((seat, index) =>{
              if(seat.seatID == seatID && seat.rowID == rowID) state.selectedSeats.splice(index, 1);
            })
          }
        }
      }

      else{
        if(seat.status == 'available'){
          seat.status = 'unavailable'
        }
        else if(seat.status == 'unavailable'){
          seat.status = 'available'
        }
      }
    },
  },

  //ACTIONS
  actions: {
    toggleSeatState({commit}, data){
      commit('toggleSeatState', data);
    },

    toggleAllSeats({commit}, type){
      commit('toggleAllSeats', type);
    },


    //GET DATA
    async getData({state}, {url, stateObject, type='list'}){
	  //[ukupno u prodaji, slobodno, prodano, gratis, pretplata, sponzorska]
          var fix_reports_about_play = {938:[173,8,5,0,160,0],941:[173,11,1,0,161,0],943:[173,0,17,0,156,0],944:[173,0,39,0,134,0],935:[173,13,45,0,115,0],947:[243,18,51,0,174,0],952:[243,0,69,0,174,0],940:[243,18,81,0,144,0],949:[243,11,21,0,211,0],950:[243,18,39,0,186,0],951:[243,1,42,4,196,0],953:[206,2,8,0,196,0],942:[206,0,42,0,164,0],955:[206,3,23,5,175,0],962:[253,0,0,253,0,0],946:[253,3,118,11,121,0],956:[253,3,32,0,218],957:[253,2,33,0,218,0],937:[253,3,164,5,81,0],945:[253,0,88,10,155,0],958:[0,0,0,0,0,0],959:[253,0,52,10,191,0],934:[133,2,71,60,0,0],967:[253,0,0,57,196],968:[253,34,14,3,202]};
          var fix_reports_income = {938:8653.82,941:8707.91,943:5714.62,944:4908.71,935:6219.94,947:17514.62,952:12736.08,940:14494.86,949:7729.39,950:18722.52,951:11457.86,953:18560.86,942:15530.51,955:16572.20,962:0.00,946:7273.39,956:11790.84,957:11790.84,937:4868.96,945:10595.92,958:0.00,959:13499.69,934:0,967:39463.64,968:14277.15}
        function fixReportsAboutPlay(data, id) { //hot garbage fix
          if (id in fix_reports_about_play) {
            var new_count = fix_reports_about_play[id];
            data['seat_count']['sold_seat'] = {sum: new_count[2] + new_count[3] + new_count[5], offline: new_count[2], gratis: new_count[3], sponsor: new_count[5]}
            data['seat_count']['sold'] = new_count[2];
            data['seat_count']['free'] = new_count[1];
            data['seat_count']['for_sale'] = new_count[0];
            data['seat_count']['subscription_count'] = new_count[4];
            data['seat_count']['gratis'] = new_count[3];
	    if (id in fix_reports_income)
               data['income']['subscription'] = fix_reports_income[id];
            data['income']['sum'] = 
              data['income']['lease'] +
              data['income']['sale'] + 
              data['income']['sponsor'] +
              data['income']['subscription'];
	    if (id == 934) {
	      data['seat_count']['sold_seat']['offline'] = 20;
	      data['seat_count']['sold_seat']['online'] = 51;
	    }
          }
          return data;
        }
	  //[ukupno u prodaji, slobodno, prodano, gratis, pretplata, sponzorska]
	function fixReportsCumulative(data) {
		for (var [pid, play] of Object.entries(data.play)) {
			for (var [per_id, performance] of Object.entries(play.performances)) {
				if (per_id in fix_reports_about_play) {
					var new_count = fix_reports_about_play[+per_id];
					//performance.count.all = new_count[2] + new_count
					performance.count.subscription = new_count[4];
					performance.count.all += new_count[4];
					var diff = new_count[3] - performance.count.free;
					performance.count.free += diff;
					play.count.free += diff;
					play.count.subscription += new_count[4];
					play.count.all += new_count[4];
					if (per_id in fix_reports_income) {
						performance.amount.subscription = fix_reports_income[+per_id];
						performance.amount.all += fix_reports_income[+per_id];
						play.amount.subscription += fix_reports_income[+per_id];
						play.amount.all += fix_reports_income[+per_id];
					}
				}
			}
		}
		return data;
	}

      let result = await new Promise((resolve) => {
        axios.get(url).then(response =>{
          if(state.apiVersion != response.headers['api-version-header'] && state.apiVersion != ''){
            state.showNotification = true;
          }
          state.apiVersion = response.headers['api-version-header'];
          resolve(response);
        }).catch(error => {
          if(state.isAdmin && error.response.status == 403) window.location.href = state.urls.login;
          else console.log(error)
        });
      });

      if(url.startsWith("https://www.hnk.hr/api/ticket/report/performance/general/")) //hot garbage fix
        result.data = fixReportsAboutPlay(result.data, +url.split('general/')[1].split('?')[0]);
      if(url.startsWith("/api/ticket/report/performance/cumulative/")) //another one
        result.data = fixReportsCumulative(result.data);

      if(type!='list') state[stateObject] = JSON.parse(JSON.stringify(result.data));
      else {
        if(state.receivedData[stateObject]) state.receivedData[stateObject].list = result.data;
        else state.receivedData[stateObject] = result.data
      }
    },

    async checkForUpdates({state}){
      let i = 0;
      let duration = 5 * 60 * 1000;
      state.notificationInterval = setInterval(() =>{
        i++;
        if(i == 5){
          clearInterval(state.notificationInterval);
          state.showNotification = true;
        }
      }, duration)
      /*await dispatch('getData', ({
        url: state.urls.updates,
        stateObject: 'updates',
      }));*/
    },

    async getExport({state}, list){
      axios.get(`${state.urls[list]}?format=xlsx`, {responseType: 'blob'}).then(response =>{
        const url = state.window.URL.createObjectURL(new Blob([response.data]));
        const link = state.window.document.createElement('a');
        link.href = url;
        link.setAttribute('download', response.headers['content-disposition'].split('; filename=')[1]);
        state.window.document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      });
    },

    async getExportWithParams({state}, req){
      axios.get(`${state.urls[req.list]}?format=xlsx${req.params}`, {responseType: 'blob'}).then(response =>{
        const url = state.window.URL.createObjectURL(new Blob([response.data]));
        const link = state.window.document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'kumulativni.xlsx');
        state.window.document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      });
    },

    async getSchema({state}){
      axios.get(state.schemaUrl).then(response =>{
        state.schema = response.data.ticket;
      })
    },

    async getDiscounts({state, dispatch}, context){
      await dispatch('getData', ({
        url: state.urls.discounts,
        stateObject: 'discounts',
        ...context
      }));
    },

    async getReportsPayment({state, dispatch}, filter){
      let url = filter !== undefined ? `${state.urls.reportsPayment}?${filter.type}=1&start_date=${filter.from}&end_date=${filter.to}` : state.urls.reportsPayment;

      await dispatch('getData', ({
        url,
        stateObject: 'reportsPayment'
      }));
    },

    async getReportsCashRegister({state, dispatch}, filter){
      let date = null;
      if(filter == undefined){
        date = new Date();
        date = date.toLocaleDateString('hr-HR');
      }
      let url = filter !== undefined ? `${state.urls.reportsCashRegister}?start_date=${filter.from}&end_date=${filter.to}&kind=${filter.kind}` : `${state.urls.reportsCashRegister}?start_date=${date}&end_date=${date}&kind=offline`;
      await dispatch('getData', ({
        url,
        stateObject: 'reportsCashRegister'
      }));
    },

    async getReportsCash({state, dispatch}, filter){
      let date = null;
      state.pageLoaded = false;
      if(filter == undefined){
        date = new Date();
        date = date.toLocaleDateString('hr-HR');
      }
      let url = filter !== undefined ? `${state.urls.reportsCash}?start_date=${filter.from}&end_date=${filter.to}&kind=${filter.kind}` : `${state.urls.reportsCash}?start_date=${date}&end_date=${date}&kind=offline`;
      await dispatch('getData', ({
        url,
        stateObject: 'reportsCash'
      }));
      state.pageLoaded = true;
    },

    async getReportsPerformanceGeneral({state, dispatch}, filter){
      let url = filter !== undefined ? `${state.urls.reportsPerformanceGeneral}?kind=${filter.kind}&period_kind=${filter.periodKind}&period=${filter.period}&year=${filter.year}` : state.urls.reportsPerformanceGeneral;

      //let url = filter !== undefined ? `${state.urls.reportsPerformanceGeneral}?kind=${filter.kind}&start_date=${filter.from}&end_date=${filter.to}` : state.urls.reportsPerformanceGeneral;
      await dispatch('getData', ({
        url,
        stateObject: 'reportsPerformanceGeneral'
      }));
    },

    async getReportsInGuests({state, dispatch}, filter){
      let url = filter !== undefined ? `${state.urls.reportsInGuests}?start_date=${filter.from}&end_date=${filter.to}` : state.urls.reportsInGuests;
      await dispatch('getData', ({
        url,
        stateObject: 'reportsInGuests',
        type: 'object',
      }));
    },

    async getReportsAboutPlay({state, dispatch}, filter){
      let url = filter !== undefined ? `${state.urls.reportsAboutPlay}${filter.performance}?start_date=${filter.from}&end_date=${filter.to}` : state.urls.reportsAboutPlay;
      await dispatch('getData', ({
        url,
        stateObject: 'reportsAboutPlay'
      }));
    },

    async getReportsPlay({state, dispatch}, id){
      await dispatch('getData', ({
        url: `${state.urls.reportsPlay}${id}/`,
        stateObject: 'selectedObject',
        type: 'object',
      }));
    },

    async getReportsPlayOnline({state, dispatch}, id){
      await dispatch('getData', ({
        url: `${state.urls.reportsPlayOnline}${id}/`,
        stateObject: 'selectedObject',
        type: 'object',
      }));
    },

    async getReportsGratisByDate({state, dispatch}, id){
      await dispatch('getData', ({
        url: `${state.urls.reportsGratisByDate}${id}/`,
        stateObject: 'selectedObject',
        type: 'object',
      }));
    },

    async getReportsGeneral({state, dispatch}, filter){
      let url = filter !== undefined ? `${state.urls.reportsGeneral}?${filter.type}=1&start_date=${filter.from}&end_date=${filter.to}` : state.urls.reportsGeneral;
      await dispatch('getData', ({
        url,
        stateObject: 'reportsGeneral'
      }));
    },

    async getReportsIncome({state, dispatch}, filter){
      let url = null;
      let today = new Date().toLocaleDateString('hr-HR')
      if(filter !== undefined) url = `${state.urls.reportsIncome}?start_date=${filter.from}&end_date=${filter.to}`;
      else url = `${state.urls.reportsIncome}?start_date=${today}&end_date=${today}`;
      await dispatch('getData', ({
        url,
        stateObject: 'reportsIncome'
      }));
    },

    async getSubscriptions({state, dispatch}){
      await dispatch('getData', ({
        url: state.urls.subscription,
        stateObject: 'subscriptions'
      }));
      await dispatch('getData', ({
        url: state.urls.seasons,
        stateObject: 'seasons'
      }));
      state.activeSeasonID = state.receivedData.seasons.list[0].id;
    },

    async getSubscribersExport({state, dispatch}){
      await dispatch('getData', ({
        url: state.urls.subscribersExport,
        stateObject: 'subscribersExport'
      }));
    },

    async getPerformance({state, dispatch}, {url}){
      await dispatch('getData', ({
        url,
        stateObject: 'selectedObject',
        type: 'object',
      }));
    },

    async getPerformances({state, dispatch}, filter){
      let url = state.urls.performances+'?';
      if(filter !== undefined){
        if(filter.hasOwnProperty('date') && filter.date.from != '' && filter.date.to != ''){
          url+=`start_date=${filter.date.from.toLocaleDateString('hr-HR')}&end_date=${filter.date.to.toLocaleDateString('hr-HR')}&active=${filter.active}`
        } else if(filter.hasOwnProperty('play') && filter.play != '') url+=`play=${parseInt(filter.play)}&active=${filter.active}`
        else url+=`active=${filter.active}`
      }
      await dispatch('getData', ({
        url,
        stateObject: 'performances'
      }));
    },

    async getTransactionData({state, dispatch}, seat){
      let url = `${state.urls.transactionsTicket}?seat=${seat}&performance=${state.selectedObject.id}`;
      if(!state.isTicket) url = `${state.urls.transactionsSubscription}?seat=${seat}&subscription=${state.theatre.id}`;
      await dispatch('getData', ({
        url,
        stateObject: 'currentTransaction',
        type: 'object',
      }));
    },

    async getTheatre({state, dispatch}, {url}){
      state.theatreLoaded = false;
      await dispatch('getData', ({
        url,
        stateObject: 'theatre',
        type: 'object',
      }));
      state.selectedSeats = [];
      state.theatreLoaded = true;
	   if ('performance_date' in state.theatre) {
			var [d, m, y] = state.theatre.performance_date.split('.');
      var [h, i, s] = state.theatre.performance_time.split(':');
			var day = new Date(y, m-1, d, h, i, s);
			var today = new Date();
			//today.setHours(0); today.setMinutes(0); today.setSeconds(0);
      console.log("performance", day);
      console.log("today", today);
			state.performanceOver = day < today;
	   }
      if(!state.isAdmin){
        if(!state.isTheatre) await dispatch('getPricelists', {id: state.theatre.id, webprice: true})
        else dispatch('setSeatPrices');
      }
    },

    async getEmptyTheatre({state, dispatch}){
      await dispatch('getData', ({
        url: state.urls.emptyTheatre,
        stateObject: 'theatre',
        type: 'object',
      }));
    },


    async getSubscribers({state, dispatch}, filter){
      await dispatch('getData', ({
        url: `${state.urls.subscribers}?search=${filter.name}&subscription=${filter.subscription}`,
        stateObject: 'subscribers'
      }));
    },

    async getShowScreens({state, dispatch}){
      await dispatch('getData', ({
        url: state.urls.showScreen,
        stateObject: 'showScreens'
      }));
    },

    async getShowScreen({state, dispatch}, filter){
      await dispatch('getData', ({
        url: `${state.urls.showScreen}?screen=${filter}`,
        stateObject: 'showScreen'
      }));
    },

    async getSearchedData({state, dispatch}, filter){
      await dispatch('getData', ({
        url: `${state.urls[filter.stateObject]}?search=${filter.filter}`,
        stateObject: filter.stateObject
      }));
    },

    async getTransactions({state, dispatch}, id){
      let stateObject = id !== undefined ? 'currentTransaction' : 'transactions';
      let type = id !== undefined ? 'object' : 'list';
      let mainUrl = state.isTheatre || state.previousTab.tab == 'ticketTheatre' || state.currentTab.tab == 'ticketTheatre' || state.isTicket ? state.urls.transactionsTicket : state.urls.transactionsSubscription;
      let url = id !== undefined ? `${mainUrl}${id}/` : mainUrl;
      if(id !== undefined){
        if(id.hasOwnProperty('performance')) {
          stateObject = 'ticketSales';
          url = `${mainUrl}?performance=${id.performance}`
          type = 'list'
        }
        else if(id.hasOwnProperty('id')){
          url = `${mainUrl}?id=${id.id}`;
          type = 'list'
        }
        else if(id.hasOwnProperty('buyer')){
          url = `${mainUrl}?buyer=${id.buyer}`;
          type = 'list'
        }
        else if(id.hasOwnProperty('start_date')){
          url = `${mainUrl}?start_date=${id.start_date}&end_date=${id.end_date}`;
          type = 'list'
        }
      }

      if(state.currentTab.tab == 'ticketSales'){
        stateObject = 'ticketSales';
        mainUrl = state.urls.transactionsTicket;
      }
      else if(state.currentTab.tab == 'subscriptionSales'){
        stateObject = 'subscriptionSales';
        mainUrl = state.urls.transactionsSubscription;
      }

      if(id === undefined){
        let today = new Date();
        today = today.toLocaleDateString('hr-HR');
        url = `${mainUrl}?start_date=${today}&end_date=${today}`
      }

      await dispatch('getData', ({
        url, stateObject, type
      }));
    },

    async getOffers({state, dispatch}, filter){
      let url = `${state.urls.transactionsTicket}?offer=1`
      if(filter !== undefined){
        if(filter.hasOwnProperty('partner')) url+=`&partner=${filter.partner}`;
        else if(filter.hasOwnProperty('id')) url+=`&id=${filter.id}`
        else if(filter.hasOwnProperty('buyer')) url+=`&buyer=${filter.buyer}`;
        else if(filter.hasOwnProperty('performance')) url+=`&performance=${filter.performance}`
        else if(filter.hasOwnProperty('start_date')) url+=`&expiry_start_date=${filter.start_date}&expiry_end_date=${filter.end_date}`;
        else if(filter.hasOwnProperty('payment_start_date')) url+=`&payment_start_date=${filter.payment_start_date}&payment_end_date=${filter.payment_end_date}`;
      } else{
        let today = new Date();
        today = today.toLocaleDateString('hr-HR');
        url = `${url}&start_date=${today}&end_date=${today}`
      }
      await dispatch('getData', ({
        url,
        stateObject: 'offers'
      }));
    },

    async getSold({state, dispatch}, filter){
      let url = `${state.urls.transactionsTicket}?sold=1`;
      let search = true;
      if(filter !== undefined){
        if(filter.hasOwnProperty('id')) url+=`&id=${filter.id}`
        else if(filter.hasOwnProperty('buyer')) url+=`&buyer=${filter.buyer}`;
        else if(filter.hasOwnProperty('performance')) url+=`&performance=${filter.performance}`;
        else if(filter.hasOwnProperty('start_date')) url+=`&payment_start_date=${filter.start_date}&payment_end_date=${filter.end_date}`;
      } else{
        let today = new Date();
        today = today.toLocaleDateString('hr-HR');
        url = `${url}&start_date=${today}&end_date=${today}`
      }

      if(filter !== undefined && filter.payment_type != 'all'){
        url+=`&payment_type=${filter.payment_type}`;
      }

      if(filter !== undefined){
        let key = null;
        for(key in filter){
          if(filter[key] == ''){
            search = false;
            break;
          }
        }
      }

      if(search){
        await dispatch('getData', ({
          url,
          stateObject: 'sold'
        }));
      }
    },

    async getPricelists({state, dispatch}, {id, webprice=false}){
      let url = `${state.urls.pricelists}?subscription_bundle=${id}`;
      if(webprice) url+=`&web_price=True`

      await dispatch('getData', ({
        url,
        stateObject: 'pricelists'
      }));
      dispatch('setSeatPrices');
    },


    //PATCH - UPDATE
    updatePricelists({state, dispatch}, {id, context}){
      return new Promise((resolve) => {
        axios.patch(`${state.urls.pricelists}${id}/`, context, {headers: {'X-CSRFToken': state.csrf}}).then(response =>{
          if(response.status == 200){
            state.receivedData.pricelists.list.filter((pricelist) => {return pricelist.id == id})[0].prices = response.data.prices;
            state.dialogs.priceChange = false;
            dispatch('setSeatPrices');
          }
          resolve();
        }).catch(error => {
          console.log(error);
        });
      });
    },

    updateSubscription({state}, {context}){
      axios.patch(state.urls.subscriptionBundle+state.theatre.id+'/', context, {headers: {'X-CSRFToken': state.csrf, 'Content-type': 'application/json'}}).then(response =>{
        if(response.status == 200){
          state.theatre = response.data;
        }
      });
    },

    async updateTransaction({state, dispatch, commit}, {context, list=''}){
      let url = '';

      if(Array.isArray(state.currentTransaction) && state.currentTransaction.length !== undefined){
        state.currentTransaction = state.currentTransaction[0];
      }

      if(state.isTheatre || state.previousTab.tab == 'ticketTheatre' || context.isFromPage || state.currentTab.tab == 'ticketTheatre' || state.isTicket){
        url = state.urls.transactionsTicket
      } else{
        url = state.urls.transactionsSubscription;
      }

      if(state.currentTransaction !== null && state.currentTransaction.kind == 'coupon'){
        url = state.urls.transactionsCoupon;
      }

      if(context.hasOwnProperty('showTransaction')){
        dispatch('setActiveTab', 'transactionDetails');
        delete context.showTransaction;
      }

      if(context.hasOwnProperty('getTheatre')){
        dispatch('getTheatre', {url: `${state.urls.performances}${state.currentTransaction.data.performance_id}/`});
        delete context.getTheatre;
      }

      if(context.hasOwnProperty('isTicket') || context.hasOwnProperty('isFromPage')){
        url = state.urls.transactionsTicket;
        delete context.isTicket;
      }

      let result = await new Promise((resolve) => {
        axios.patch(url+state.currentTransaction.id+'/', context, {headers: {'X-CSRFToken': state.csrf}}).then(response =>{
          if(response.status == 200){
            commit('setErrors', []);
            state.currentTransaction = JSON.parse(JSON.stringify(response.data));
            if(list != ''){
              for(let i = 0; i < state.receivedData[list].list.length; i++){
                if(state.receivedData[list].list[i].id == state.currentTransaction.id){
                  let key = null;
                  for(key in response.data){
                    state.receivedData[list].list[i][key] = response.data[key];
                  }
                  if(list == 'reservations' || list == 'transactionsCoupon') state.receivedData[list].list.splice(i, 1);
                  break;
                }
              }
            }

            if(!state.isAdmin && context.status != 'aborted'){
              window.location.href = `/corvus-redirect/${response.data.data.hash}/`
            }
          }
          resolve(response)
        }).catch(error => {
          if(state.isAdmin){
            let errors = [];
            let key = null;
            for(key in error.response.data){
              errors.push(error.response.data[key])
            }
            commit('setErrors', errors);
          }
        });
      })
    },

    async editTransaction({state, dispatch, commit}, {context}){
      let result = await new Promise((resolve) => {
        axios.post(state.urls.transactionTicketEdit, context, {headers: {'X-CSRFToken': state.csrf}}).then(response =>{
          if(response.status == 200){
            commit('setErrors', []);
            state.currentTransaction = JSON.parse(JSON.stringify(response.data));
            dispatch('setActiveTab', 'transactionDetails');
          }
          resolve(response)
        }).catch(error => {
          console.log(error)
          if(state.isAdmin){
            let errors = [];
            let key = null;
            for(key in error.response.data){
              errors.push(error.response.data[key])
            }
            commit('setErrors', errors)
          }
        });
      })
    },

    //CREATE - UPDATE - DELETE
    async manipulateData({dispatch}, {stateObject, type}){
      await dispatch(type, {stateObject})
    },

    //UPDATE
    async updateSelectedData({state, commit}, {stateObject}){
      commit('setErrors', []);
      let updatedObject = state.receivedData[stateObject].list.filter((item) => item.id == state.selectedObject.id)[0];
      await axios.patch(`${state.urls[stateObject]}${state.selectedObject.id}/`, state.selectedObject, {headers: {'X-CSRFToken': state.csrf}}).then(response =>{
        if(response.status == 200){
          let index = state.receivedData[stateObject].list.indexOf(updatedObject);
          state.receivedData[stateObject].list[index] = Object.assign(state.receivedData[stateObject].list[index], response.data);
        }
      }).catch(error =>{
          let errors = [];
          let key = null;
          for(key in error.response.data){
            errors.push(error.response.data[key])
          }
          commit('setErrors', errors);
      });
    },

    postSubscriber({state}, context){
      axios.post(state.urls.subscriberPostUrl, context, {headers: {'X-CSRFToken': state.csrf}}).then(response =>{

      });
    },

    async cancelTransaction({state, dispatch}, {status, list='', stornoInfo=''}){
      let context = null;
      if(state.currentTransaction.kind == 'coupon'){
        context = {
          'coupon': state.currentTransaction.data.coupon,
          'status': status,
        }
      } else{
        if(state.isTheatre || state.currentTab.tab == 'ticketTheatre'){
          context = {
            'subscription': state.currentTransaction.data.subscription,
            'status': status
          }
        } else{
          let performance = state.currentTransaction.data.performance !== undefined ? state.currentTransaction.data.performance : state.currentTransaction.data.performance_id
          context = {
            'performance': performance,
            'status': status
          }
        }
      }
      if(stornoInfo != ''){
        context['stornoInfo'] = stornoInfo;
      }

      await dispatch('updateTransaction', {context, list: list});
      if(state.currentTransaction !== null && state.currentTransaction.kind == 'coupon'){
        dispatch('setActiveTab', 'transactionsCoupon');
      }
    },


    //POST - CREATE
    async createSubscription({dispatch, state}, {context}){
      await axios.post(state.urls.subscriptionBundle, context, {headers: {'X-CSRFToken': state.csrf}}).then(response =>{
        if(response.status == 201){
          state.theatre = response.data;
          if(context.rows){
            dispatch('setActiveTab', 'subscriptionTheatre');
            dispatch('getPricelists', {id: response.data.id});
          }
        }
      });
    },

    async editSubscriptionDetails({state}, context){
      let activeSeasonUrl = state.selectedObject.seasons.find(i => i.season_id === state.activeSeasonID).url;
      let url = activeSeasonUrl + 'details/'
      await axios.patch(url, context, {headers: {'X-CSRFToken': state.csrf}}).then(response =>{
        
      }).catch(e =>{

      });
    },

    async createTransaction({dispatch, state, commit}, {context}){
      state.clicked = true;
      state.createTransactionError = false;
      let isAdminCreate = context.adminCreate
      let url = state.isTheatre || state.currentTab.tab == 'ticketTheatre' || context.isFromPage ? state.urls.transactionsTicket : state.urls.transactionsSubscription;
      if(context['expiry_date'] !== undefined) url = state.urls.transactionsTicket;
      let getTheatre = context.getTheatre;
      let showTransaction = context.showTransaction;
      delete context.getTheatre;
      delete context.showTransaction;
      delete context.adminCreate;

      if(context.kind == 'coupon'){
        url = state.urls.transactionsCoupon;
      }

      state.loading = true;
      await axios.post(url, context, {headers: {'X-CSRFToken': state.csrf}}).then(response =>{
        if(response.status == 201){
          state.loading = false;
          commit('setErrors', []);
          state.currentTransaction = JSON.parse(JSON.stringify(response.data));
          if(getTheatre && state.errors.length == 0) dispatch('getTheatre', {url: `${state.urls.performances}${context.performance}/`});
          if(showTransaction && state.errors.length == 0) dispatch('setActiveTab', 'transactionDetails');
        }
      }).catch(error => {
        state.loading = false;
        if((state.isTheatre && !state.isAdmin) || state.isSubscription === true){
          let errors = ['Nažalost mjesta su u međuvremenu zauzeta'];
          let key = null;
          for(key in error.response.data.seats){
            if (Array.isArray(error.response.data.seats[key]))
              errors.push(error.response.data.seats[key].join('::'))
          }
          commit('setErrors', errors);
          dispatch('getTheatre', {url: state.urls.subscriptionBundle});
        }
        if(state.isAdmin || isAdminCreate){
          let key = null;
          let errors = [];
          for(key in error.response.data){
            errors.push(error.response.data[key])
          }
          commit('setErrors', errors);
        }

        if(isAdminCreate) state.createTransactionError = true;
      });

      state.clicked = false;
    },

    //POST SELECTED DATA
    async postSelectedData({state}, {stateObject}){
      await axios.post(state.urls[stateObject], state.selectedObject, {headers: {'X-CSRFToken': state.csrf}}).then(response =>{
        if(response.status == 201){
          state.receivedData[stateObject].list.push(response.data);
        }
      });
    },

    resendMail({state}, {context}){
      axios.post(state.urls.resendMail, context, {headers: {'X-CSRFToken': state.csrf}}).then(response =>{
        if(response.status == 200){
          state.dialogs.resendMail = false;
        }
      })
    },

    sendScreen({state}, {context}){
      axios.post(state.urls.showScreen, context, {headers: {'X-CSRFToken': state.csrf}});
    },

		checkPromoCode({state}, {context}) {
			axios.get(state.urls.checkPromoCode + '?p=' + context.promoCode, {headers: {'X-CSRFToken': state.csrf}}).then(response => {
				if (response.data) {
					state.promoCode = response.data;
				} else {
					state.promoCode = undefined;
				}
			})
		},

    //DELETE
    deleteSubscription({dispatch, state}, {subscription}){
      let url = null;
      subscription.seasons.forEach((season) =>{
        if(season.season_id == state.activeSeasonID){
          url = season.url;
        }
      })

      axios.delete(url, {headers: {'X-CSRFToken': state.csrf}}).then(response =>{
        if(response.status == 204){
          dispatch('getSubscriptions')
        }
      });
    },

    //DELETE SELECTED DATA
    deleteSelectedData({state}, {stateObject}){
      axios.delete(`${state.urls[stateObject]}${state.selectedObject.id}/`, {headers: {'X-CSRFToken': state.csrf}}).then(response =>{
        if(response.status == 204){
          let deletedObject = state.receivedData[stateObject].list.filter((item) => item.id == state.selectedObject.id)[0];
          state.receivedData[stateObject].list.splice(state.receivedData[stateObject].list.indexOf(deletedObject), 1);
        }
      });
    },

    //HELPERS
    async setActiveTab({state, dispatch}, tab){
      state.pageLoaded = false;
      state.loading = false;
      let key = null;
      if(state.selectedSeats.length > 0) state.selectedSeats = [];
      state.previousTab = JSON.parse(JSON.stringify(state.currentTab));

      for(key in state.receivedData){
        if(key != tab) state.receivedData[key].tab = false;
        else{
          state.currentTab = JSON.parse(JSON.stringify(state.receivedData[tab]));
          state.currentTab.tab = key;
          state.receivedData[tab].tab = true;

          if(state.receivedData[tab].hasOwnProperty('additionalGet')){
            for(let i = 0; i < state.receivedData[tab].additionalGet.length; i++){
              await dispatch(state.receivedData[tab].additionalGet[i]);
            }
          }

          if(state.receivedData[tab].hasOwnProperty('additionalSimpleGet')){
            for(let i = 0; i < state.receivedData[tab].additionalSimpleGet.length; i++){
              await dispatch('getData', ({
                url: state.urls[state.receivedData[tab].additionalSimpleGet[i]],
                stateObject: state.receivedData[tab].additionalSimpleGet[i],
              }));
            }
          }

          if(state.simpleData.includes(tab)){
            if(state.urls[tab] !== undefined){
              let url = state.urls[tab];
              if(tab === 'performances') url+='?order_by=performance_date'
              await dispatch('getData', ({
                url: url,
                stateObject: tab,
              }));
            }
          }

          if(state.receivedData[tab].get){
            await dispatch(state.receivedData[tab].get);
          }
        }
      }

      if(tab == 'subscriptionTheatre' || tab == 'subscriptions') state.currentStageKind = 1;

      if(state.ticketTabs.includes(tab) && state.isAdmin) state.isTicket = true;
      else state.isTicket = false;
      state.router.push(`/hnk-4dm1n-t1ck3t/${state.receivedData[tab].url}`);
      setTimeout(() => {
        state.pageLoaded = true;
      }, 1);
    },

    setSeatPrices({state}){
      let key = null;
      let discountPricelist = state.receivedData.pricelists.list.filter(d =>{return d.web_price === false})[0];
      let regularPricelist = state.receivedData.pricelists.list.filter(d =>{return d.web_price === true})[0];

      if(state.isAdmin || state.isSubscription){
        for(key in state.categories){
          state.categories[key].price = regularPricelist.prices[key];
        }

        for(key in state.categories){
          let price = 0;
          if(discountPricelist && discountPricelist.prices[key] != 0){
            price = discountPricelist.prices[key];
          } else {
            price = regularPricelist.prices[key]
          }

          state.categories[key].discount = price;
        }
      }

      if(state.isTheatre){
        let key = null;
        for(key in state.categories){
          if(state.theatre.pricelist_data.category[key] !== undefined){
            state.categories[key].price = state.theatre.pricelist_data.category[key][state.defaultPricelistID];
          } else delete state.categories[key]
        }
      }
    },
  }
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js